<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #monthTab>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="默认当月" name="1"></el-tab-pane>
          <el-tab-pane label="上月" name="2"></el-tab-pane>
        </el-tabs>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="profitrate" slot-scope="params">
        <span>{{ params.params.profitrate }}%</span>
      </template>
      <template slot="business" slot-scope="params">
        <span>{{ params.params.business }}%</span>
      </template>
      <template slot="cartarget" slot-scope="params">
        <span>{{ params.params.cartarget }}%</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      activeName: '1',
      baseUrl: 'cockpit',
      getListUrl: 'runcount',
      showIndex: true,
      breadcrumb: [
        { name: "财务管理" },
        { name: "车队运营统计表" },
      ],
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.fleet,
          label: "车队长",
          placeholder: "",
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请输入车牌号",
          type: "text",
        },
        {
          label: "时间选择",
          keyName: "time",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        // { prop: "id", label: "序号" },
        { prop: "license", label: "车牌号" },
        { prop: "driver", label: "司机姓名" },
        { prop: "infreight", label: "运费总额", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
        { prop: "daypay", label: "出车费用", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
        { prop: "fixedpay", label: "固定费用", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
        { prop: "repair", label: "维修费用", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
        { prop: "money", label: "费用总额", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
        { prop: "profit", label: "毛利额", align: 'right', className: 'pr30', sortable: true, minwidth: 90 },
        { prop: "profitrate", label: "毛利率", align: 'right', className: 'pr30', sortable: true, slot: 'profitrate', minwidth: 90 },
        { prop: "business", label: "营业成本率", align: 'right', className: 'pr30', sortable: true, slot: 'business', minwidth: 110 },
        { prop: "cartarget", label: "目标达成率", align: 'right', className: 'pr30', sortable: true, slot: 'cartarget', minwidth: 100 },
        { keyName: "volume", label: "加油升数", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
        { keyName: "mileage", label: "行驶里程", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
        { prop: "fuel", label: "综合油耗", align: 'right', className: 'pr30', sortable: true, minwidth: 100 },
      ],
      // getTotalProperty: ['freight','daypay','fixedpay','repair','money','profit'],
    };
  },
  methods: {
    handleClick() {
      // console.log(this.activeName)
      this.formInline.time = ''
      this.formInline.month = this.activeName;
      this.getList();
    },
  },
  mounted() {
    this.getFleet();
    this.getList();
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs {
  width: 172px;
  float: left;
  margin-right: 40px;

  .el-tabs__nav-wrap {
    border: 1px solid #2691FF;
    border-radius: 3px;
    padding: 0;

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      display: none;
    }

    .el-tabs__item {
      width: 85px;
      padding: 0;
      text-align: center;
      color: #2691FF;

      &.is-active {
        color: #fff;
        background: #2691FF;
      }
    }
  }
}

/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

/deep/ .el-tabs__active-bar {
  height: 0;
}

/deep/ .el-form--inline .el-form-item:nth-child(3) .el-range-editor.el-input__inner {
  width: 225px;
}
</style>
